import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición como "se maneja sus propios errores".
 *
 * El interceptor de errores, por defecto, avisa al usuario con un modal, deja
 * la excepción en el application insights y propaga solo el mensaje como texto.
 * Eso sirve para las pantallas, pero no para las peticiones en las que un
 * fallo es parte del flujo normal: leer una llave que todavía no existe, por
 * ejemplo, devuelve 404 y no es nada que el usuario tenga que ver.
 *
 * Con esta marca el interceptor se aparta: no muestra nada y propaga el
 * `HttpErrorResponse` original, para que quien llamó pueda mirar el `status`.
 */
export const HANDLES_OWN_ERRORS = new HttpContextToken<boolean>(() => false);

/**
 * Contexto listo para pasarle a una petición que maneja sus propios errores.
 * @returns {HttpContext} Devuelve el contexto con la marca puesta
 */
export function handlesOwnErrors(): HttpContext {
  return new HttpContext().set(HANDLES_OWN_ERRORS, true);
}
